// extracted by mini-css-extract-plugin
module.exports = {"filter-footer":"filter-footer_filter-footer__G1tti","filter-footer__apply-button":"filter-footer_filter-footer__apply-button__i530d"};